export enum CaptureQueueCursorType {
  mostRecentlyCreated = 'most_recently_created',
  mostRecentlyVerified = 'most_recently_verified',
  mostRecentlyFaxed = 'most_recently_faxed',
  leastRecentlyFaxed = 'least_recently_faxed',
  highestEstimatedValue = 'highest_estimated_value',
  highestPendingEstimatedValue = 'highest_pending_estimated_value',
  highestWipEstimatedValue = 'highest_wip_estimated_value',
}
